import {
  call, put, select,
} from 'redux-saga/effects';

import FrontSonda from '@gc-npm/utils.monitoring.front-sonda';
const {  CloudTraceService } = require('@gc-npm/gcp-services.open-telemetry');

import { actions as uiActions } from '@/reducers/ui';
import { actions as clientActions } from '@/reducers/client';
import { actions as recomendatorActions } from '@/reducers/recomendator';
import { actions as modulesActions } from '@/reducers/modules';

import recomendatorInit from '@/sagas/adabyron/recomendator/init';
import recomendPackagesPromise from '@/sagas/adabyron/recomendator/packages';
import {
  API_STATUS, URL_FULL_CONFIG, TIPOS_R2R,
} from '@/utils/constants';
import { isArrayNotEmpty, isEmpty } from '@/utils/validations';
import { getAndSendTaggingInfo, getIfBaseInRecommendations } from '@/utils/recomendador';

import { navigate2Url } from '@/sagas/ui';
import { getTaponInfo } from '@/utils';

const filePath = '/sagas/public.js';

const contextStore = (state) => state.main.context;
const mainStore = (state) => state.main;
const recomendatorStore = (state) => state.recomendator;

const applyAllIncompatibilities = ({ incompatibles = {}, currentFiltersInfo = {} }) => {
  const result = { ...currentFiltersInfo };

  Object.keys(currentFiltersInfo).forEach((key) => {
    const currentItems = currentFiltersInfo[key];
    const currentIncompatibles = incompatibles[key] || [];

    // Si no hay incompatibilidades, todo a true
    if (!Array.isArray(currentIncompatibles) || currentIncompatibles.length === 0) {
      result[key] = currentItems?.map((item) => ({ ...item, show: true }));
      return;
    }

    // Si hay "all", todo a false
    if (currentIncompatibles.includes('all')) {
      result[key] = currentItems?.map((item) => ({ ...item, show: false }));
      return;
    }

    // Si hay incompatibilidades definidas, aplicarlas
    result[key] = currentItems?.map((item) => ({
      ...item,
      show: !currentIncompatibles.includes(item.id),
    }));
  });

  return result;
};

const removeFilteredItemsFromSelected = ({
  key,
  selectedItems,
  filteredInfo,
  isArray = false,
}) => {
  const removedItems = [];

  if (isArray) {
    if (
      selectedItems
      && selectedItems[key]
      && Array.isArray(selectedItems[key])
      && filteredInfo
      && filteredInfo[key]
      && filteredInfo[key].length > 0
    ) {
      selectedItems[key] = selectedItems[key].filter((id) => {
        const item = filteredInfo[key].find((i) => i.id === id);
        const shouldKeep = item ? item.show !== false : true;

        if (!shouldKeep && item) {
          removedItems.push(item);
        }

        return shouldKeep;
      });
    }
  } else {
    const val = selectedItems && selectedItems[key];
    const item = filteredInfo && filteredInfo[key]?.find(({ id }) => id === val);

    if (val && item?.show === false) {
      removedItems.push(item);
      selectedItems[key] = null;
    }
  }

  return removedItems;
};

export function* selectRecomendator({ data }) {
  const cloudTraceServiceselectRecomendator = new CloudTraceService('front/selectRecomendator');
  cloudTraceServiceselectRecomendator.startSpan()
  const context = yield select(contextStore);
  const recomendator = yield select(recomendatorStore);

  const {
    selectedItems: selectedItemsData,
    removeSessionStorage,
    fiber,
    mobileLines,
    tvChannels,
    originSelectors,
  } = data || {};
  let selectedItemsDataTemp = null;

  if (selectedItemsData) {
    selectedItemsDataTemp = selectedItemsData
  } else {
    selectedItemsDataTemp = recomendator?.selectedItems;
  }
  const filtersInfo = recomendator?.data?.filters || {};
  const currentFiltersInfo = { ...filtersInfo };
  let filteredInfo = { ...filtersInfo };

  //  Clonado seguro de selectedItems
  const oldSelectedItems = {
    fiber: selectedItemsDataTemp?.fiber ?? null,
    mobileLines: selectedItemsDataTemp?.mobileLines ?? null,
    tvChannels: Array.isArray(selectedItemsDataTemp?.tvChannels)
      ? [...selectedItemsDataTemp.tvChannels]
      : [],
  };

  const frontSonda = new FrontSonda({
    processName: 'selectRecomendator',
    context,
    filePath,
  });

  const incompatibleItemms = {
    fiber: [],
    mobileLines: [],
    tvChannels: [],
  };

  try {
    if (removeSessionStorage && typeof window !== 'undefined') {
      sessionStorage.removeItem('selection');
    }

    if (fiber) {
      if (oldSelectedItems.fiber === fiber) {
        oldSelectedItems.fiber = null;
      } else {
        oldSelectedItems.fiber = fiber;
      }

      if (oldSelectedItems.fiber) {
        const filterItem = currentFiltersInfo.fiberSpeeds.find(
          (item) => item.id === oldSelectedItems.fiber,
        );
        if (filterItem?.incompatibles) {
          if (filterItem.incompatibles.mobileLines) {
            incompatibleItemms.mobileLines = filterItem.incompatibles.mobileLines;
          }
          if (filterItem.incompatibles.tvChannels) {
            incompatibleItemms.tvChannels = filterItem.incompatibles.tvChannels;
          }
        }
      }

      filteredInfo = applyAllIncompatibilities({
        incompatibles: incompatibleItemms,
        currentFiltersInfo,
      });
    }

    if (mobileLines) {
      oldSelectedItems.mobileLines = mobileLines;
    }

    if (typeof tvChannels === 'string') {
      if (oldSelectedItems.tvChannels.includes(tvChannels)) {
        oldSelectedItems.tvChannels = oldSelectedItems.tvChannels.filter(
          (item) => item !== tvChannels,
        );
      } else {
        oldSelectedItems.tvChannels = [...oldSelectedItems.tvChannels, tvChannels];
      }
    } else if (
      tvChannels
      && Array.isArray(tvChannels)
      && tvChannels.length > 0
    ) {
      // ✅ Evitar duplicados
      tvChannels.forEach((eachTvModule) => {
        if (!oldSelectedItems.tvChannels.includes(eachTvModule)) {
          oldSelectedItems.tvChannels.push(eachTvModule);
        }
      });
    }

    yield put(recomendatorActions.filterItems({ data: filteredInfo }));

    // ⚠️ Verificar si hay elementos seleccionados que han sido filtrados
    if (oldSelectedItems) {
      removeFilteredItemsFromSelected({
        key: 'fiber',
        selectedItems: oldSelectedItems,
        filteredInfo,
      });
      removeFilteredItemsFromSelected({
        key: 'mobileLines',
        selectedItems: oldSelectedItems,
        filteredInfo,
      });
      removeFilteredItemsFromSelected({
        key: 'tvChannels',
        isArray: true,
        selectedItems: oldSelectedItems,
        filteredInfo,
      });
    }
    if (!originSelectors) {
      yield put(recomendatorActions.setSelectedItems({ data: oldSelectedItems }));
    }
    cloudTraceServiceselectRecomendator.endSpan()
  } catch (error) {
    console.error(error);
    cloudTraceServiceselectRecomendator.endSpanWithError(error)
    yield put(recomendatorActions.resetRecomendPackagesStatus());
    frontSonda.errorMessage({
      error: `error selectRecomendador ${error}`,
    });
  }
}

export function* recomendPackages({ data }) {
  const cloudTraceServiceRecomendPackagesRecomendator = new CloudTraceService('front/recomendPackagesRecomendator');
  cloudTraceServiceRecomendPackagesRecomendator.startSpan()
  const {
    tvchanels,
    extraModules,
    build,
    opVersus,
    originSelectors = false,
    oldTvChanels,
    selectedItemsData,
    bundles,
  } = data || {};

  yield put(recomendatorActions.setRecomendPackagesStatus(API_STATUS.LOADING));

  const context = yield select(contextStore);
  const main = yield select(mainStore);
  const recomendator = yield select(recomendatorStore);

  let selectedItemsDataTemp = null;
  if (selectedItemsData) {
    selectedItemsDataTemp = selectedItemsData
  } else {
    const selectedItems = recomendator?.selectedItems || {};
    // Clonar objeto para evitar mutar el state directamente
    selectedItemsDataTemp = { ...selectedItems };
    if (tvchanels && isArrayNotEmpty(tvchanels)) {
      const uniqueById = Array.from(
        new Map(tvchanels.map((item) => [item, item])).values(),
      );
      selectedItemsDataTemp.tvChannels = uniqueById;
    }
  }

  // Aquí puedes continuar con selectedItemsData sin tocar selectedItems

  if (extraModules && isArrayNotEmpty(extraModules)) {
    selectedItemsDataTemp.extraModules = extraModules;
  }
  const frontSonda = new FrontSonda({
    processName: 'selectRecomendator',
    context,
    filePath,
  });
  const params = {
    fiberSpeed: '',
    mobileLines: '',
    tvChannels: [],
    extraModules: [],
    rule: '',
    bundles: '',
  }

  params.originSelectors = originSelectors
  try {
    // primero vamos a rellenar cada item
    params.fiberSpeed = selectedItemsDataTemp?.fiber || '';
    params.mobileLines = selectedItemsDataTemp?.mobileLines || '';
    if (Number(params.mobileLines) > 0) {
      params.mobileLines = Number(params.mobileLines)
      yield call(selectRecomendator, {
        data: {
          mobileLines: params.mobileLines,
          originSelectors: params.originSelectors,
          selectedItems: selectedItemsDataTemp,
        },
      })
    }
    let rule = '';
    if (typeof window !== 'undefined' && !build && main && main?.x) {
      rule = `x=${main.x}`;
    }
    params.rule = rule;

    if (selectedItemsDataTemp.extraModules
      && Array.isArray(selectedItemsDataTemp.extraModules)
      && selectedItemsDataTemp.extraModules.length > 0
    ) {
      params.extraModules = selectedItemsDataTemp.extraModules;
    }
    const uniqueTvChannels = Array.from(
      new Map(selectedItemsDataTemp?.tvChannels.map((item) => [item, item])).values(),
    );
    if (
      uniqueTvChannels
      && Array.isArray(uniqueTvChannels)
      && uniqueTvChannels.length > 0
    ) {
      const filtersInfo = recomendator?.data?.filters;
      const arrayToAdd = [];
      uniqueTvChannels.forEach((item) => {
        let objectToAdd = {
          id: item,
        }
        if (
          filtersInfo
          && filtersInfo.tvChannels
          && Array.isArray(filtersInfo.tvChannels)
          && filtersInfo.tvChannels.length > 0
        ) {
          filtersInfo.tvChannels.forEach((tvChanelInfo) => {
            if (tvChanelInfo.id === item && tvChanelInfo.upgrade) {
              objectToAdd = {
                ...objectToAdd,
                ...tvChanelInfo.upgrade,
              }
            }
          });
        }
        if (objectToAdd.id) {
          arrayToAdd.push(objectToAdd);
        }
      })
      params.tvChannels = arrayToAdd;
    }

    if (originSelectors) {
      // netflix logic to upgrade
      const targetModules = ['498_268', '498_269', '498_3544'];
      const moduleIdSet = new Set(targetModules);

      // 1. Obtener los IDs actuales de primer nivel
      const idsInTopLevel = params.tvChannels
        ?.map((item) => item.id)
        .filter((id) => moduleIdSet.has(id));

      // 2. Reemplazar en modulesUpgrade si corresponde
      const updatedTvChannels = params.tvChannels?.map((item) => {
      // No tocar los módulos objetivos directamente
        if (!moduleIdSet.has(item.id)) {
          const updatedModules = item.modulesUpgrade?.map((mod) => {
            if (mod === '498_268' && idsInTopLevel.includes('498_269')) {
              return '498_269';
            }
            if (mod === '498_268' && idsInTopLevel.includes('498_3544')) {
              return '498_3544';
            }
            if (mod === '498_269' && idsInTopLevel.includes('498_3544')) {
              return '498_3544';
            }
            if (mod === '498_269' && idsInTopLevel.includes('498_268')) {
              return '498_268';
            }
            if (mod === '498_3544' && idsInTopLevel.includes('498_268')) {
              return '498_268';
            }
            if (mod === '498_3544' && idsInTopLevel.includes('498_269')) {
              return '498_269';
            }
            return mod;
          });
          return { ...item, modulesUpgrade: updatedModules };
        }
        return item;
      });

      if (!(oldTvChanels.includes('498_269') || oldTvChanels.includes('498_268') || oldTvChanels.includes('498_3544'))) {
      // 3. Filtrar: eliminar módulos absorbidos y autoref
        const finalTvChannels = updatedTvChannels.filter((item) => {
          const isAbsorbed = moduleIdSet.has(item.id)
          && updatedTvChannels.some(
            (other) => other.modulesUpgrade.includes(item.id) && other.id !== item.id,
          );
          const isSelfRef = item && item.modulesUpgrade && item.modulesUpgrade.length === 1 && item.modulesUpgrade[0] === item.id;
          return !isAbsorbed && !isSelfRef;
        });
        params.tvChannels = finalTvChannels;
      } else {
        params.tvChannels = updatedTvChannels;
      }
    }

    // Resultado final
    if (opVersus && opVersus === 'op-versus') {
      params.rule = true;
    }
    let recomendedPackages = null;
    let textosLegales = null;
    if ((params.fiberSpeed && params.mobileLines)) {
      ({recomAndBestSellers: recomendedPackages ,textosLegales} = yield call(recomendPackagesPromise, { context, params, build }))||{};
      yield put(modulesActions.setTexts(textosLegales||null));
      
    } else if (bundles) {
      params.bundles = bundles;
      ({recomAndBestSellers: recomendedPackages,textosLegales} = yield call(recomendPackagesPromise, { context, params, build }))||{};
      yield put(modulesActions.setTexts(textosLegales||null));

    } else {
      yield put(uiActions.setNotification('Responde a todas las preguntas para ver opciones'));
      yield put(recomendatorActions.setRecomendPackagesStatus(''));
      return null;
    }
    if (
      !recomendedPackages
      || (
        recomendedPackages.recommendations
        && Array.isArray(recomendedPackages.recommendations)
        && recomendedPackages.recommendations.length === 0
      )
    ) {
      frontSonda.errorMessage({
        error: `error recomendPackages sin info, selección:  ${JSON.stringify(params)}`,
      });
      yield put(
        uiActions.setTapon({
          ...getTaponInfo(false,'500'),
          componentContent: 'respuesta recomend sin info, posibles params erroneos',
          componentProduct: `error recomendPackages sin info, selección:  ${JSON.stringify(params)}`,
        }),
      );
      return null;
    }
    if (recomendedPackages) {
      yield put(recomendatorActions.setRecomendedPackages({ data: recomendedPackages }));
      let r2rAditional = false;
      if (recomendedPackages.recommendations && Array.isArray(recomendedPackages.recommendations)) {
        recomendedPackages.recommendations.forEach((product) => {
          getAndSendTaggingInfo({
            product,
            selectedItems: selectedItemsDataTemp,
            name: 'listado-mimovistar-recomendador',
          })
          if (!r2rAditional) {
            r2rAditional = getIfBaseInRecommendations(product)
          }
        })
      }
      if (r2rAditional) {
        yield put(clientActions.setR2rType(TIPOS_R2R.ADICIONAL));
      }
      yield put(recomendatorActions.setRecomendPackagesStatus(API_STATUS.OK));
      cloudTraceServiceRecomendPackagesRecomendator.endSpan()
    }
  } catch (error) {
    console.error(error)
    cloudTraceServiceRecomendPackagesRecomendator.endSpanWithError(error)
    yield put(recomendatorActions.setRecomendPackagesStatus(API_STATUS.KO));
    yield put(
      uiActions.setTapon({
        ...getTaponInfo(false,'500'),
        componentContent: 'error recomendPackages',
        componentProduct: `${error}`,
      }),
    );
    frontSonda.errorMessage({
      error: `error recomendPackages ${error}`,
    });
  }
}

export function* initRecomendator({ build, urlParams, isProductosRecomendados, rule }) {
    const cloudTraceServiceInitRecomendator = new CloudTraceService('front/initRecomendator');
  cloudTraceServiceInitRecomendator.startSpan()
  const context = yield select(contextStore);
  const main = yield select(mainStore);
  const recomendator = yield select(recomendatorStore);

  if (recomendator?.status?.init === API_STATUS.OK) {
    if (
      recomendator
      && recomendator.data
      && recomendator.data.recomAndBestSellers
      && recomendator.data.recomAndBestSellers.bestSellers
      && Array.isArray(recomendator.data.recomAndBestSellers.bestSellers)
    ) {
      recomendator.data.recomAndBestSellers.bestSellers.forEach(
        (product) => getAndSendTaggingInfo({
          product,
          name: 'listado-bestsellers-recomendador',
        }),
      );
    }
  }
  let ruleToUse = rule;
  // if (typeof window !== 'undefined' && !build && main && main?.x) {
  //   ruleToUse = `x=${main.x}`;
  // }
  const frontSonda = new FrontSonda({
    processName: 'initRecomendator',
    context,
    filePath,
  });
  const hasBestSellers = recomendator?.data?.recomAndBestSellers?.bestSellers;
  if (
    recomendator?.status?.init !== API_STATUS.OK
    || ruleToUse
    || !hasBestSellers
    || urlParams?.rehidratate
  ) {
    // Si no es cliente y no hay info de recomendador
    yield put(recomendatorActions.setInitStatus(API_STATUS.LOADING));

    try {
      const params = {};
      params.rule = ruleToUse;
      const recomendatorData = yield call(recomendatorInit, {
        context,
        build,
        params,
      });
      if (!recomendatorData || isEmpty(recomendatorData)) {
        console.error(recomendatorData)
        // Si falla o no obtenemos respuesta deseada
        throw new ReferenceError('Respuesta erronea del servicio Recomendator Init', filePath);
      }
      yield put(modulesActions.setTexts(recomendatorData.textosLegales||null));

      yield put(recomendatorActions.setRecomendatorInfo(recomendatorData));
      if (
        recomendatorData
        && recomendatorData.recomAndBestSellers
        && recomendatorData.recomAndBestSellers.bestSellers
        && Array.isArray(recomendatorData.recomAndBestSellers.bestSellers)
        && recomendatorData.recomAndBestSellers.bestSellers.length > 0
      ) {
        recomendatorData.recomAndBestSellers.bestSellers.forEach(
          (product) => getAndSendTaggingInfo({
            product,
            name: 'listado-bestsellers-recomendador',
          }),
        );
      }
      yield put(recomendatorActions.setInitStatus(API_STATUS.OK));
      yield put(uiActions.setShowRecomendator(true));
      cloudTraceServiceInitRecomendator.endSpan()
    } catch (error) {
      console.error(error)
      cloudTraceServiceInitRecomendator.endSpanWithError(error)
      yield put(recomendatorActions.setInitStatus(API_STATUS.KO));
      frontSonda.errorMessage({
        error: 'No tenemos info del recomendador',
      });
      if (!build) {
        yield put(
          uiActions.setTapon({
            ...getTaponInfo(false,'500'),
            componentContent: 'Fallo en recom',
            componentProduct: 'initRecom',
          }),
        );
      }
    }
  }
  // miramos si tenemos que seleccionar según local
  if (!build && !isProductosRecomendados) {
    if (typeof window !== 'undefined') {
      const selection = sessionStorage.getItem('selection');
      if (selection) {
        const dataSelection = JSON.parse(selection);
        const dataToSelect = {}
        if (dataSelection.fiber && dataSelection.mobileLines) {
          dataToSelect.fiber = dataSelection.fiber;
          dataToSelect.mobileLines = dataSelection.mobileLines;
          if (dataSelection.tvChannels) {
            dataToSelect.tvChannels = [];
            dataSelection.tvChannels.forEach((tvChannel) => dataToSelect.tvChannels.push(tvChannel))
          }
          yield call(selectRecomendator, { data: { ...dataToSelect, removeSessionStorage: true } })
        }
      }
    }
  }

  if(isProductosRecomendados && !urlParams && !build) {
    frontSonda.warningMessage({
      info: `REDIRECIÓN a recomendador , no hay parámetros en url`,
    });
    const redirect = yield call(navigate2Url, {
      url: URL_FULL_CONFIG,
    });
    return redirect;
  }
  if (urlParams && isProductosRecomendados) {
    try {
      const dataToSelect = {}
      if ((urlParams.fiber && urlParams.mobileLines)) {
        dataToSelect.fiber = [];
        dataToSelect.mobileLines = [];
        urlParams.fiber.forEach((fiberItem) => dataToSelect.fiber.push(fiberItem));
        urlParams.mobileLines.forEach((mobileLine) => dataToSelect.mobileLines.push(mobileLine))
        if (urlParams.tvChannels) {
          dataToSelect.tvChannels = [];
          urlParams.tvChannels.forEach((tvChannel) => dataToSelect.tvChannels.push(tvChannel))
        }

        yield call(selectRecomendator, { data: dataToSelect })
        yield call(recomendPackages, { data: { build } })
      } else if (urlParams.bundles) {
        yield call(recomendPackages, { data: { ...urlParams, build } })
      } else {
        frontSonda.warningMessage({
          info: `no tengo parámetros correctos en productos recomendados ${JSON.stringify(urlParams)}`,
        });
        if (!build) {
          const redirect = yield call(navigate2Url, {
            url: URL_FULL_CONFIG,
            params: urlParams,
          });
          return redirect;
        }
      }
    } catch (error) {
      frontSonda.errorMessage({
        error,
        info: 'fallo en productos recomendados',
      });
      yield put(
        uiActions.setTapon({
          ...getTaponInfo(false,'500'),
          componentContent: 'Fallo en recom',
          componentProduct: 'initRecom',
        }),
      );
    }
  }
  /* let selectionsFromPreviusPage = null;
  if(typeof window !== 'undefined' && (window.location.pathname === '/fibra-y-movil/')) {
    selectionsFromPreviusPage = localStorage?.getItem('selection');
    if(selectionsFromPreviusPage) {
      selectionsFromPreviusPage = JSON.parse(selectionsFromPreviusPage);
      yield call(selectRecomendator, {data: selectionsFromPreviusPage})
    }

  } */
}
